<div>
  <ngx-spinner [type]="spinnerType"></ngx-spinner>
  <router-outlet></router-outlet>
</div>
